require('./mortgageRequestUnpaidFees.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const classNames = require('classnames');
// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ Loans
const { okLoansComponents } = require('ok-loans');
// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const MortgageRequestUnpaidFeesFilter = require('components/mortgageRequest/mortgageRequestUnpaidFees/mortgageRequestUnpaidFeesFilter/mortgageRequestUnpaidFeesFilter');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');
const { EmptyState } = require('commonsComponents/emptyState');
const LoanCollectiveTag = okLoansComponents.LoanCollectiveTag;
// @ constants
const { DATE_FORMAT_ES } = require('constants/index');
const { DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');
// @utils
const { recordLinkV2 } = require("utilities/tagging");
// @utilities
const { commonCatalogueFilters, commonFilterAnalyticsId, commonCatalogue, commonAnalyticsId } = require( '../../../utilities/taggingCommonCatalogue' );

class MortgageRequestUnpaidFees extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filterSettingsOpen: false
        };

        this.onButtonClick = this.onButtonClick.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.setFilter = this.setFilter.bind(this);
        this.handleClearFilter = this.handleClearFilter.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
    }

    onButtonClick(number) {
        const { history, immLoan, onClickDetail, isAresFlag } = this.props;
        onClickDetail();
        recordLinkV2(commonCatalogue[commonAnalyticsId.COMMON_BUTTON]('ver cobros'));
        isAresFlag ? history.push(`/myprofile/loans-mortgages/ares-loans/${immLoan.get('loanId')}/unpaid-fees/detail/${number}`) :
         history.push(`/myprofile/loans-mortgages/loans/${immLoan.get('loanId')}/unpaid-fees/detail/${number}`);
    }

    handleNextPage() {
        const { requestNextPage, immLoan } = this.props;
        recordLinkV2(commonCatalogue[commonAnalyticsId.COMMON_BUTTON]('cargar mas'));
        requestNextPage(immLoan);
    }

    buildTableBody(unpaidFeesList) {
        return unpaidFeesList.map((item, index) => {
            const date = DateHelper.buildFormattedDate(item.get('date'), DATE_FORMAT_ES);
            const plainAmountInterestObject = getPlainAmountObject(item.get('interest'));
            const plainAmountObject = getPlainAmountObject(item.get('value'));
            const language = getLanguage();

            return (
                <OKTableRow key={index} id={`mortgage-unpaid-fees-table-row-${index}`}>
                    <OKTableCell className="mortgage-request-unpaid-fees__table-row-date">
                        {date}
                    </OKTableCell>
                    <OKTableCell className="mortgage-request-unpaid-fees__table-row-number">
                        {item.get('number')}
                    </OKTableCell>
                    <OKTableCell className="mortgage-request-unpaid-fees__table-row-state mortgage-request-unpaid-fees__table-row-state--capitalize">
                        {item.get('state').toLowerCase()}
                    </OKTableCell>
                    <OKTableCell className="mortgage-request-unpaid-fees__table-row-interest">
                        <OneLineSymbolAmount
                            amountObject={plainAmountInterestObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountInterestObject, true)} />
                    </OKTableCell>
                    <OKTableCell className="mortgage-request-unpaid-fees__table-row-value">
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                    </OKTableCell>
                    <OKTableCell className="mortgage-request-unpaid-fees__table-row-value">
                        {this.buildButton(item, index)}
                    </OKTableCell>
                </OKTableRow>
            );
        });
    }

    buildButton(item, index) {
        const isFetching = item.get('isFetchingDetail');
        return (
            <OKButton
                key={index}
                id={`mortgage-unpaid-fees-table-button-${index}`}
                modifier="secondary"
                disabled={item.get('disableButton') || isFetching}
                loading={isFetching}
                onClick={() => this.onButtonClick(index)}
            >
                <FormattedText value="mortgageRequestUnpaidFees-chargeDetail" />
            </OKButton>
        );
    }

    buildTable(unpaidFeesList) {
        const tableBody = this.buildTableBody(unpaidFeesList);
        return (
            <div>
                <OKTable id="mortgage-unpaid-fees-table" className="mortgage-request-unpaid-fees__table">
                    <thead>
                        <OKTableRow asHeader={true}>
                            <OKTableCell asHeader={true}>
                                <FormattedText value="mortgageRequestUnpaidFees-date" format="firstUppercase" />
                            </OKTableCell>
                            <OKTableCell asHeader={true}>
                                <FormattedText value="mortgageRequestUnpaidFees-number" format="firstUppercase" />
                            </OKTableCell>
                            <OKTableCell asHeader={true}>
                                <FormattedText value="mortgageRequestUnpaidFees-situation" format="firstUppercase" />
                            </OKTableCell>
                            <OKTableCell asHeader={true}>
                                <FormattedText value="mortgageRequestUnpaidFees-interests" format="firstUppercase" />
                            </OKTableCell>
                            <OKTableCell asHeader={true}>
                                <FormattedText value="mortgageRequestUnpaidFees-value" format="firstUppercase" />
                            </OKTableCell>
                            <OKTableCell asHeader={false}>
                            </OKTableCell>
                        </OKTableRow>
                    </thead>
                    <tbody>
                        {tableBody}
                    </tbody>
                </OKTable>
            </div>
        );
    }

    handleToggleFilters() {
        const filterSettingsOpen = !this.state.filterSettingsOpen;
        if(filterSettingsOpen) {
            recordLinkV2(commonCatalogueFilters[commonFilterAnalyticsId.FILTER_BUTTON_CLICK]());
        }
        this.setState({ filterSettingsOpen });
    }

    requestUnpaidFees() {
        const { immLoan, getUnpaidFees } = this.props;
        getUnpaidFees(immLoan);
    }

    setFilter(filters) {
        this.handleToggleFilters();
        this.props.setFilter(filters);
        this.requestUnpaidFees();
    }

    handleClearFilter() {
        this.props.clearFilter();
        this.requestUnpaidFees();
    }

    buildBadge() {
        const { immLoan } = this.props;

        return (
            <LoanCollectiveTag
                extraClass="mortgage-request-unpaid-fees__collective-tag"
                immLoan={immLoan}
            />
        )
    }

    buildEmptyMessage() {
        const { getUnpaidFees, isAresFlag, immLoan, immMortgageRequestUnpaidFees } = this.props;
        const error = immMortgageRequestUnpaidFees.get('error');
        let emptyStateMessage = formatText('mortgageRequestUnpaidFees-emptyMessage');
        let iconType = "noitems-banking" ;
        let retryButton;
        const handleOnClick = () => {
            recordLinkV2(commonCatalogue[commonAnalyticsId.COMMON_BUTTON]('reintentar'));
            getUnpaidFees(immLoan);
        }
        if (isAresFlag && error) {
            //ARES user error screen changes
            retryButton = (
                <OKButton modifier="primary" inverse={true} onClick={handleOnClick}>
                    {formatText('loanRepaymentPlan-retry')}
                </OKButton>
            );
            emptyStateMessage = "Error al cargar las Cuotas impagadas";
            iconType="nointernet-banking";
        }
        return (
            <div className="text-center mortgage-request-unpaid-fees-view__padded-block">
                <EmptyState primaryText={emptyStateMessage} textRegular={false} darkbg={false} iconType={iconType} button={retryButton}/>
            </div>
        );
    }

    buildHeader(immFilter) {
        const isDateFilterActive = immFilter.getIn(['date', 'isActive']);
        const badge = this.buildBadge();
        const headerClasses = classNames('mortgage-request-unpaid-fees__header', {
            'mortgage-request-unpaid-fees__header--has-filters': isDateFilterActive
        });

        return (
            <div className={headerClasses}>
                <div className="mortgage-request-unpaid-fees__header-title">
                    <OKBoxTitle value={formatText('mortgageRequestUnpaidFees-tableTitle')} />
                    {badge}
                </div>
                {badge}
                <div className="mortgage-request-unpaid-fees__header-filters">
                    <OKButton
                        id="btn_mortgageRequestUnpaidFees_filterButton"
                        modifier="task"
                        onClick={this.handleToggleFilters}
                    >
                        <i className="icon icon-filtrar mortgage-request-unpaid-fees__header-filters--settings-icon" />
                    </OKButton>
                </div>
            </div>
        );
    }

    buildContentFilter(immFilter) {
        const immFilterDate = immFilter.get('date');
        const isDateFilterActive = immFilter.getIn(['date', 'isActive']);

        let contentFilter;

        if (isDateFilterActive) {
            const language = getLanguage();
            const labelFromDate = immFilterDate.get('from').locale(language).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));
            const labelToDate = immFilterDate.get('to').locale(language).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));
            contentFilter = (
                <div className="mortgage-request-unpaid-fees__content-filter">
                    <LabelFilterRange
                        key="filter-date"
                        from={labelFromDate}
                        to={labelToDate}
                        closeCallback={() => this.handleClearFilter()} // Because there is only one filter to clear
                    />
                </div>
            );
        }

        return contentFilter;
    }

    buildViewMoreUnpaidFessButton(isEndOfList, isFetchingNextPage) {
        const { isAresFlag } = this.props;
        if (isFetchingNextPage) {
            return (
                <LoadingSection />
            )
        } else if (isEndOfList === 'N') {
            return (
                <div className="mortgage-request-unpaid-fees__button-view-more">
                    <OKButton modifier="link-complementary" onClick={this.handleNextPage}>
                        {isAresFlag ? 'Ver mas Cobros' : <FormattedText value="mortgageRequestUnpaidFees-moreMovements" />}
                    </OKButton>
                </div>
            )
        }
    }

    render() {
        const { immMortgageRequestUnpaidFees, immLoan, isAresFlag } = this.props;
        const immFilter = immMortgageRequestUnpaidFees.get('filters');
        const header = this.buildHeader(immFilter);
        const contentFilter = this.buildContentFilter(immFilter);
        const unpaidFeesList = immMortgageRequestUnpaidFees.get('unpaidFeesList');
        const isEndOfList = immMortgageRequestUnpaidFees.get('isEndOfList');
        const isFetchingNextPage = immMortgageRequestUnpaidFees.get('isFetchingNextPage');
        const error = immMortgageRequestUnpaidFees.get('error');
        const viewMoreButton = this.buildViewMoreUnpaidFessButton(isEndOfList, isFetchingNextPage);
        let dataBlock;

        if (immMortgageRequestUnpaidFees.get('isFetching')) {
            dataBlock = <LoadingSection />
        } else if (unpaidFeesList.size === 0 || error) {
            dataBlock = this.buildEmptyMessage();
        } else {
            dataBlock = this.buildTable(unpaidFeesList);
        }

        return (
            <div>
                <MortgageRequestUnpaidFeesFilter
                    immFilter={immFilter}
                    onCloseClick={this.handleToggleFilters}
                    setFilter={this.setFilter}
                    isOpen={this.state.filterSettingsOpen}
                    immLoan={immLoan}
                    isAresFlag={isAresFlag}
                />
                {header}
                {contentFilter}
                {dataBlock}
                {viewMoreButton}
            </div>
        );
    }
}

MortgageRequestUnpaidFees.propTypes = {
    history: PropTypes.object.isRequired,
    immMortgageRequestUnpaidFees: PropTypes.object.isRequired,
    immLoan: PropTypes.object.isRequired,
    getUnpaidFees: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired,
    clearFilter: PropTypes.func.isRequired,
    onClickDetail: PropTypes.func,
    requestNextPage: PropTypes.func,
    isAresFlag: PropTypes.bool
};

module.exports = withRouter(MortgageRequestUnpaidFees);
